/**
 * Pointer-following 3D tilt for [data-tilt] imagery.
 * Only runs for a fine hover pointer with motion allowed; touch and reduced motion stay flat.
 * Writes --tilt-x / --tilt-y (deg) and --sheen-x / --sheen-y (%) for the CSS in config/styles.css.
 */
const motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
const MAX_TILT = 7;

let active = null;
let frame = 0;
let lastEvent = null;

function reset(el) {
  if (!el) return;
  el.removeAttribute('data-tilting');
  el.style.removeProperty('--tilt-x');
  el.style.removeProperty('--tilt-y');
}

function paint() {
  frame = 0;
  if (!active || !lastEvent) return;
  const rect = active.getBoundingClientRect();
  const x = Math.min(Math.max((lastEvent.clientX - rect.left) / rect.width, 0), 1);
  const y = Math.min(Math.max((lastEvent.clientY - rect.top) / rect.height, 0), 1);
  const rtl = document.documentElement.dir === 'rtl' ? -1 : 1;
  active.style.setProperty('--tilt-x', `${((0.5 - y) * MAX_TILT * 2).toFixed(2)}deg`);
  active.style.setProperty('--tilt-y', `${((x - 0.5) * MAX_TILT * 2 * rtl).toFixed(2)}deg`);
  active.style.setProperty('--sheen-x', `${(x * 100).toFixed(1)}%`);
  active.style.setProperty('--sheen-y', `${(y * 100).toFixed(1)}%`);
}

document.addEventListener(
  'pointermove',
  (event) => {
    if (event.pointerType !== 'mouse' || !motionOk.matches || !finePointer.matches) return;
    const target = event.target instanceof Element ? event.target.closest('[data-tilt]') : null;
    if (target !== active) {
      reset(active);
      active = target;
      if (active) active.setAttribute('data-tilting', '');
    }
    if (!active) return;
    lastEvent = event;
    if (!frame) frame = requestAnimationFrame(paint);
  },
  { passive: true },
);

document.addEventListener('pointerleave', () => {
  reset(active);
  active = null;
});

motionOk.addEventListener('change', () => {
  reset(active);
  active = null;
});
